import { render, staticRenderFns } from "./EditAvatar.vue?vue&type=template&id=e41ec32a&"
import script from "./EditAvatar.vue?vue&type=script&lang=js&"
export * from "./EditAvatar.vue?vue&type=script&lang=js&"
import style0 from "./EditAvatar.vue?vue&type=style&index=0&id=e41ec32a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports